/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */
import * as References from './AiAgentInstancesChirpServiceV2';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstance
 */
export const GET_AGENT_INSTANCE_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstance';
export const GET_AGENT_INSTANCE_QUERY: RegisteredQuery<
  'result',
  References.GetAgentInstanceRequestType,
  References.GetAgentInstanceResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_INSTANCE_QUERY_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(
    request: References.GetAgentInstanceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentInstanceResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAgentInstanceRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesByIDs
 */
export const GET_AGENT_INSTANCES_BY_IDS_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesByIDs';
export const GET_AGENT_INSTANCES_BY_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetAgentInstancesByIDsRequestType,
  References.GetAgentInstancesByIDsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_INSTANCES_BY_IDS_QUERY_FIELD_NAME,
  args: ['ids'],
  fetcher(
    request: References.GetAgentInstancesByIDsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentInstancesByIDsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAgentInstancesByIDsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesMetadataByIDs
 */
export const GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesMetadataByIDs';
export const GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetAgentInstancesMetadataByIDsRequestType,
  References.GetAgentInstancesMetadataByIDsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_INSTANCES_METADATA_BY_IDS_QUERY_FIELD_NAME,
  args: ['ids'],
  fetcher(
    request: References.GetAgentInstancesMetadataByIDsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentInstancesMetadataByIDsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAgentInstancesMetadataByIDsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesWithSnapshots
 */
export const GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesWithSnapshots';
export const GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY: RegisteredQuery<
  'result',
  References.GetAgentInstancesWithSnapshotsRequestType,
  References.GetAgentInstancesWithSnapshotsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY_FIELD_NAME,
  args: ['items'],
  fetcher(
    request: References.GetAgentInstancesWithSnapshotsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentInstancesWithSnapshotsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAgentInstancesWithSnapshotsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentInstancesByWorkflowId
 */
export const GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentInstancesByWorkflowId';
export const GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY: RegisteredQuery<
  'result',
  References.GetAgentInstancesByWorkflowIdRequestType,
  References.GetAgentInstancesByWorkflowIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY_FIELD_NAME,
  args: ['workflowId'],
  fetcher(
    request: References.GetAgentInstancesByWorkflowIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentInstancesByWorkflowIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAgentInstancesByWorkflowIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getActiveAgentInstances
 */
export const GET_ACTIVE_AGENT_INSTANCES_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getActiveAgentInstances';
export const GET_ACTIVE_AGENT_INSTANCES_QUERY: RegisteredQuery<
  'result',
  References.GetActiveAgentInstancesRequestType,
  References.GetActiveAgentInstancesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_ACTIVE_AGENT_INSTANCES_QUERY_FIELD_NAME,
  args: ['visibility', 'pageLength', 'offset'],
  fetcher(
    request: References.GetActiveAgentInstancesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetActiveAgentInstancesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getActiveAgentInstancesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#listAgentInstances
 */
export const LIST_AGENT_INSTANCES_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_listAgentInstances';
export const LIST_AGENT_INSTANCES_QUERY: RegisteredQuery<
  'result',
  References.ListAgentInstancesRequestType,
  References.ListAgentInstancesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_AGENT_INSTANCES_QUERY_FIELD_NAME,
  args: [
    'authorName',
    'updatedBy',
    'searchTerm',
    'adminVisibilityFilter',
    'runLimitStatusFilter',
    'pageLength',
    'createdBy',
    'visibilities',
    'visibility',
    'requiredAccessType',
    'sortField',
    'sortDirection',
    'statuses',
    'permissionTypeFilters',
    'agentScopeFilter',
    'offset',
  ],
  fetcher(
    request: References.ListAgentInstancesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListAgentInstancesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listAgentInstancesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#searchAgentInstances
 */
export const SEARCH_AGENT_INSTANCES_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_searchAgentInstances';
export const SEARCH_AGENT_INSTANCES_QUERY: RegisteredQuery<
  'result',
  References.SearchAgentInstancesRequestType,
  References.SearchAgentInstancesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: SEARCH_AGENT_INSTANCES_QUERY_FIELD_NAME,
  args: [
    'searchTerms',
    'pageLength',
    'createdBy',
    'visibilities',
    'visibility',
    'requiredAccessType',
    'sortField',
    'sortDirection',
    'statuses',
    'permissionTypeFilters',
    'agentScopeFilter',
    'offset',
  ],
  fetcher(
    request: References.SearchAgentInstancesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SearchAgentInstancesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.searchAgentInstancesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createAgentInstance
 */
export const CREATE_AGENT_INSTANCE_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createAgentInstance';
export const CREATE_AGENT_INSTANCE_MUTATION: RegisteredQuery<
  'result',
  References.CreateAgentInstanceRequestType,
  References.CreateAgentInstanceResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['instance', 'triggerFlowIds', 'permissions', 'feedbackCorrelationId'],
  fetcher(
    request: References.CreateAgentInstanceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateAgentInstanceResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createAgentInstanceRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceV2
 */
export const UPDATE_AGENT_INSTANCE_V2_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceV2';
export const UPDATE_AGENT_INSTANCE_V2_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAgentInstanceV2RequestType,
  References.UpdateAgentInstanceV2ResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_V2_MUTATION_FIELD_NAME,
  args: [
    'id',
    'instance',
    'triggerFlowIds',
    'permissions',
    'feedbackCorrelationId',
    'recommendationMetadata',
  ],
  fetcher(
    request: References.UpdateAgentInstanceV2RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAgentInstanceV2ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAgentInstanceV2Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceV3
 */
export const UPDATE_AGENT_INSTANCE_V3_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceV3';
export const UPDATE_AGENT_INSTANCE_V3_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAgentInstanceV3RequestType,
  References.UpdateAgentInstanceV3ResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_V3_MUTATION_FIELD_NAME,
  args: [
    'id',
    'instance',
    'triggerFlowIds',
    'permissions',
    'feedbackCorrelationId',
    'recommendationMetadata',
    'clientHeadSnapshotId',
    'forceCreate',
  ],
  fetcher(
    request: References.UpdateAgentInstanceV3RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAgentInstanceV3ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAgentInstanceV3Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#patchAgentInstance
 */
export const PATCH_AGENT_INSTANCE_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_patchAgentInstance';
export const PATCH_AGENT_INSTANCE_MUTATION: RegisteredQuery<
  'result',
  References.PatchAgentInstanceRequestType,
  References.PatchAgentInstanceResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: PATCH_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['id', 'instance'],
  fetcher(
    request: References.PatchAgentInstanceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PatchAgentInstanceResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.patchAgentInstanceRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentMetadata
 */
export const UPDATE_AGENT_METADATA_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentMetadata';
export const UPDATE_AGENT_METADATA_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAgentMetadataRequestType,
  References.UpdateAgentMetadataResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_AGENT_METADATA_MUTATION_FIELD_NAME,
  args: ['id', 'name', 'description', 'icon'],
  fetcher(
    request: References.UpdateAgentMetadataRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAgentMetadataResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAgentMetadataRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentAvailability
 */
export const UPDATE_AGENT_AVAILABILITY_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentAvailability';
export const UPDATE_AGENT_AVAILABILITY_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAgentAvailabilityRequestType,
  References.UpdateAgentAvailabilityResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_AGENT_AVAILABILITY_MUTATION_FIELD_NAME,
  args: ['id', 'isBreezeEnabled'],
  fetcher(
    request: References.UpdateAgentAvailabilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAgentAvailabilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAgentAvailabilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#unpublishAgentInstance
 */
export const UNPUBLISH_AGENT_INSTANCE_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_unpublishAgentInstance';
export const UNPUBLISH_AGENT_INSTANCE_MUTATION: RegisteredQuery<
  'result',
  References.UnpublishAgentInstanceRequestType,
  References.UnpublishAgentInstanceResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UNPUBLISH_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['id', 'unpublishReasons', 'pendingChanges'],
  fetcher(
    request: References.UnpublishAgentInstanceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UnpublishAgentInstanceResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.unpublishAgentInstanceRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#resetToLatestTemplate
 */
export const RESET_TO_LATEST_TEMPLATE_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_resetToLatestTemplate';
export const RESET_TO_LATEST_TEMPLATE_MUTATION: RegisteredQuery<
  'result',
  References.ResetToLatestTemplateRequestType,
  References.ResetToLatestTemplateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: RESET_TO_LATEST_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['instanceId'],
  fetcher(
    request: References.ResetToLatestTemplateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ResetToLatestTemplateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.resetToLatestTemplateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#softDeleteAgentInstance
 */
export const SOFT_DELETE_AGENT_INSTANCE_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_softDeleteAgentInstance';
export const SOFT_DELETE_AGENT_INSTANCE_MUTATION: RegisteredQuery<
  'result',
  References.SoftDeleteAgentInstanceRequestType,
  References.SoftDeleteAgentInstanceResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SOFT_DELETE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(
    request: References.SoftDeleteAgentInstanceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SoftDeleteAgentInstanceResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.softDeleteAgentInstanceRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#softDeleteAgentInstanceV2
 */
export const SOFT_DELETE_AGENT_INSTANCE_V2_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_softDeleteAgentInstanceV2';
export const SOFT_DELETE_AGENT_INSTANCE_V2_MUTATION: RegisteredQuery<
  'result',
  References.SoftDeleteAgentInstanceV2RequestType,
  References.SoftDeleteAgentInstanceV2ResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SOFT_DELETE_AGENT_INSTANCE_V2_MUTATION_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(
    request: References.SoftDeleteAgentInstanceV2RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SoftDeleteAgentInstanceV2ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.softDeleteAgentInstanceV2Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createInstanceFromTemplate
 */
export const CREATE_INSTANCE_FROM_TEMPLATE_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createInstanceFromTemplate';
export const CREATE_INSTANCE_FROM_TEMPLATE_MUTATION: RegisteredQuery<
  'result',
  References.CreateInstanceFromTemplateRequestType,
  References.CreateInstanceFromTemplateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_INSTANCE_FROM_TEMPLATE_MUTATION_FIELD_NAME,
  args: ['templateId', 'objective', 'components', 'builtInTools', 'detach'],
  fetcher(
    request: References.CreateInstanceFromTemplateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateInstanceFromTemplateResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createInstanceFromTemplateRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#createInstanceFromTemplateByGlobalId
 */
export const CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_createInstanceFromTemplateByGlobalId';
export const CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION: RegisteredQuery<
  'result',
  References.CreateInstanceFromTemplateByGlobalIdRequestType,
  References.CreateInstanceFromTemplateByGlobalIdResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION_FIELD_NAME,
  args: [
    'globalId',
    'globalIdString',
    'objective',
    'components',
    'builtInTools',
    'desiredStatus',
    'detach',
  ],
  fetcher(
    request: References.CreateInstanceFromTemplateByGlobalIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateInstanceFromTemplateByGlobalIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createInstanceFromTemplateByGlobalIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#cloneAgentInstance
 */
export const CLONE_AGENT_INSTANCE_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_cloneAgentInstance';
export const CLONE_AGENT_INSTANCE_MUTATION: RegisteredQuery<
  'result',
  References.CloneAgentInstanceRequestType,
  References.CloneAgentInstanceResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CLONE_AGENT_INSTANCE_MUTATION_FIELD_NAME,
  args: ['instanceId', 'cloneName', 'cloneStatus', 'detach'],
  fetcher(
    request: References.CloneAgentInstanceRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CloneAgentInstanceResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.cloneAgentInstanceRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#cloneAgentsForFlow
 */
export const CLONE_AGENTS_FOR_FLOW_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_cloneAgentsForFlow';
export const CLONE_AGENTS_FOR_FLOW_MUTATION: RegisteredQuery<
  'result',
  References.CloneAgentsForFlowRequestType,
  References.CloneAgentsForFlowResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CLONE_AGENTS_FOR_FLOW_MUTATION_FIELD_NAME,
  args: ['instanceIds', 'newWorkflowId'],
  fetcher(
    request: References.CloneAgentsForFlowRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CloneAgentsForFlowResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.cloneAgentsForFlowRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getInstancesByTemplateIds
 */
export const GET_INSTANCES_BY_TEMPLATE_IDS_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getInstancesByTemplateIds';
export const GET_INSTANCES_BY_TEMPLATE_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetInstancesByTemplateIdsRequestType,
  References.GetInstancesByTemplateIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_INSTANCES_BY_TEMPLATE_IDS_QUERY_FIELD_NAME,
  args: ['templateIds'],
  fetcher(
    request: References.GetInstancesByTemplateIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstancesByTemplateIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstancesByTemplateIdsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getInstancesByGlobalId
 */
export const GET_INSTANCES_BY_GLOBAL_ID_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getInstancesByGlobalId';
export const GET_INSTANCES_BY_GLOBAL_ID_QUERY: RegisteredQuery<
  'result',
  References.GetInstancesByGlobalIdRequestType,
  References.GetInstancesByGlobalIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_INSTANCES_BY_GLOBAL_ID_QUERY_FIELD_NAME,
  args: ['globalId', 'globalIdString'],
  fetcher(
    request: References.GetInstancesByGlobalIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetInstancesByGlobalIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getInstancesByGlobalIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceOwner
 */
export const UPDATE_AGENT_INSTANCE_OWNER_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceOwner';
export const UPDATE_AGENT_INSTANCE_OWNER_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAgentInstanceOwnerRequestType,
  References.UpdateAgentInstanceOwnerResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_OWNER_MUTATION_FIELD_NAME,
  args: ['agentInstanceId', 'newOwnerId'],
  fetcher(
    request: References.UpdateAgentInstanceOwnerRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAgentInstanceOwnerResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAgentInstanceOwnerRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#updateAgentInstanceFromSnapshot
 */
export const UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_updateAgentInstanceFromSnapshot';
export const UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION: RegisteredQuery<
  'result',
  References.UpdateAgentInstanceFromSnapshotRequestType,
  References.UpdateAgentInstanceFromSnapshotResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME,
  args: [
    'instanceId',
    'snapshotId',
    'additionalSetupInputs',
    'authorName',
    'triggerFlowIds',
    'permissions',
  ],
  fetcher(
    request: References.UpdateAgentInstanceFromSnapshotRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateAgentInstanceFromSnapshotResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateAgentInstanceFromSnapshotRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#cloneInstanceFromSnapshot
 */
export const CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_cloneInstanceFromSnapshot';
export const CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION: RegisteredQuery<
  'result',
  References.CloneInstanceFromSnapshotRequestType,
  References.CloneInstanceFromSnapshotResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION_FIELD_NAME,
  args: ['instanceId', 'snapshotId', 'cloneName', 'cloneStatus', 'detach'],
  fetcher(
    request: References.CloneInstanceFromSnapshotRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CloneInstanceFromSnapshotResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.cloneInstanceFromSnapshotRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#validateAgentInstanceReadiness
 */
export const VALIDATE_AGENT_INSTANCE_READINESS_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_validateAgentInstanceReadiness';
export const VALIDATE_AGENT_INSTANCE_READINESS_QUERY: RegisteredQuery<
  'result',
  References.ValidateAgentInstanceReadinessRequestType,
  References.ValidateAgentInstanceReadinessResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: VALIDATE_AGENT_INSTANCE_READINESS_QUERY_FIELD_NAME,
  args: ['instanceId', 'instancePayload', 'runtimeInputs'],
  fetcher(
    request: References.ValidateAgentInstanceReadinessRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ValidateAgentInstanceReadinessResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.validateAgentInstanceReadinessRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#validateAgentInstanceReadinessV2
 */
export const VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_validateAgentInstanceReadinessV2';
export const VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY: RegisteredQuery<
  'result',
  References.ValidateAgentInstanceReadinessV2RequestType,
  References.ValidateAgentInstanceReadinessV2ResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY_FIELD_NAME,
  args: ['agentInstanceId'],
  fetcher(
    request: References.ValidateAgentInstanceReadinessV2RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ValidateAgentInstanceReadinessV2ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.validateAgentInstanceReadinessV2Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#bulkValidateAgentInstancesReadiness
 */
export const BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_bulkValidateAgentInstancesReadiness';
export const BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY: RegisteredQuery<
  'result',
  References.BulkValidateAgentInstancesReadinessRequestType,
  References.BulkValidateAgentInstancesReadinessResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY_FIELD_NAME,
  args: ['instanceIds'],
  fetcher(
    request: References.BulkValidateAgentInstancesReadinessRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.BulkValidateAgentInstancesReadinessResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.bulkValidateAgentInstancesReadinessRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#bulkCreateAgentInstances
 */
export const BULK_CREATE_AGENT_INSTANCES_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_bulkCreateAgentInstances';
export const BULK_CREATE_AGENT_INSTANCES_MUTATION: RegisteredQuery<
  'result',
  References.BulkCreateAgentInstancesRequestType,
  References.BulkCreateAgentInstancesResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: BULK_CREATE_AGENT_INSTANCES_MUTATION_FIELD_NAME,
  args: ['instances'],
  fetcher(
    request: References.BulkCreateAgentInstancesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.BulkCreateAgentInstancesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.bulkCreateAgentInstancesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#bulkCreateAgentInstancesByKey
 */
export const BULK_CREATE_AGENT_INSTANCES_BY_KEY_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_bulkCreateAgentInstancesByKey';
export const BULK_CREATE_AGENT_INSTANCES_BY_KEY_MUTATION: RegisteredQuery<
  'result',
  References.BulkCreateAgentInstancesByKeyRequestType,
  References.BulkCreateAgentInstancesByKeyResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: BULK_CREATE_AGENT_INSTANCES_BY_KEY_MUTATION_FIELD_NAME,
  args: ['instances'],
  fetcher(
    request: References.BulkCreateAgentInstancesByKeyRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.BulkCreateAgentInstancesByKeyResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.bulkCreateAgentInstancesByKeyRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#bulkSoftDeleteAgentInstances
 */
export const BULK_SOFT_DELETE_AGENT_INSTANCES_MUTATION_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_bulkSoftDeleteAgentInstances';
export const BULK_SOFT_DELETE_AGENT_INSTANCES_MUTATION: RegisteredQuery<
  'result',
  References.BulkSoftDeleteAgentInstancesRequestType,
  References.BulkSoftDeleteAgentInstancesResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: BULK_SOFT_DELETE_AGENT_INSTANCES_MUTATION_FIELD_NAME,
  args: ['instanceIds'],
  fetcher(
    request: References.BulkSoftDeleteAgentInstancesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.BulkSoftDeleteAgentInstancesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.bulkSoftDeleteAgentInstancesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getAgentConnections
 */
export const GET_AGENT_CONNECTIONS_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getAgentConnections';
export const GET_AGENT_CONNECTIONS_QUERY: RegisteredQuery<
  'result',
  References.GetAgentConnectionsRequestType,
  References.GetAgentConnectionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_AGENT_CONNECTIONS_QUERY_FIELD_NAME,
  args: ['agentInstanceId'],
  fetcher(
    request: References.GetAgentConnectionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAgentConnectionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAgentConnectionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#getGlobalAgentConnections
 */
export const GET_GLOBAL_AGENT_CONNECTIONS_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_getGlobalAgentConnections';
export const GET_GLOBAL_AGENT_CONNECTIONS_QUERY: RegisteredQuery<
  'result',
  References.GetGlobalAgentConnectionsRequestType,
  References.GetGlobalAgentConnectionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_GLOBAL_AGENT_CONNECTIONS_QUERY_FIELD_NAME,
  args: [
    'agentInstanceId',
    'filterByConnectionTypes',
    'evaluateBreakingChanges',
  ],
  fetcher(
    request: References.GetGlobalAgentConnectionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetGlobalAgentConnectionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getGlobalAgentConnectionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2#listAgentInstancesWithInvocability
 */
export const LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY_FIELD_NAME =
  'com_hubspot_ai_agent_rpc_AiAgentInstancesChirpServiceV2_listAgentInstancesWithInvocability';
export const LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY: RegisteredQuery<
  'result',
  References.ListAgentInstancesWithInvocabilityRequestType,
  References.ListAgentInstancesWithInvocabilityResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_AGENT_INSTANCES_WITH_INVOCABILITY_QUERY_FIELD_NAME,
  args: [
    'pageLength',
    'sortField',
    'sortDirection',
    'filterToBreezeEnabledOnly',
    'searchTerm',
    'offset',
  ],
  fetcher(
    request: References.ListAgentInstancesWithInvocabilityRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListAgentInstancesWithInvocabilityResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listAgentInstancesWithInvocabilityRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
